import { PropsWithChildren, ReactNode } from "react";

export function TabsContainer(props: PropsWithChildren<ReactNode>) {
    return (
        <div className="relative z-10 p-4 bg-white rounded shadow -top-1">{props.children}</div>
    )
}

export default TabsContainer;